/** Deterministic, non-authoritative identity fields present in an eBay title. */
export interface EbayTitleIdentityEvidence {
  year?: string;
  set?: string;
  number?: string;
}

const EXPLICIT_CARD_NUMBER =
  /(^|[\s(])#\s*([a-z0-9](?:[a-z0-9-]{0,15})(?:\/[a-z0-9]{1,8})?)(?=$|[\s,;:()])/i;

/**
 * Extract only fields whose boundaries are explicit in common single-card
 * listing titles. Player and parallel text intentionally remain unparsed; the
 * imported checklist roster owns those distinctions.
 */
export function ebayTitleIdentityEvidence(title: string | undefined): EbayTitleIdentityEvidence {
  const bounded = title?.trim().slice(0, 750) ?? '';
  if (bounded === '') return {};
  const numberMatch = EXPLICIT_CARD_NUMBER.exec(bounded);
  const year = /(?:^|\s)((?:19|20)\d{2})(?=(?:-\d{2,4})?\b)/.exec(bounded)?.[1];
  const hashIndex =
    numberMatch === null ? undefined : numberMatch.index + (numberMatch[1]?.length ?? 0);
  const set = hashIndex === undefined ? undefined : bounded.slice(0, hashIndex).trim();
  const number = numberMatch?.[2]?.trim();
  return {
    ...(year === undefined ? {} : { year }),
    ...(set === undefined || set === '' ? {} : { set }),
    ...(number === undefined || number === '' ? {} : { number }),
  };
}
